import { createSelector } from 'reselect';
import { selectQueues } from 'flow/selectors/queue-selectors';
import { selectSelectedOperatorMembers } from 'flow/selectors/SupervisorSelectors';

export const selectSelectedQueues = createSelector(
    [selectSelectedOperatorMembers, selectQueues],
    (operatorMembers, queues) => {
        if (!operatorMembers) return queues;
        return queues?.filter((queue) => operatorMembers.has(queue.get('key')));
    },
);
